var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "15px",
    height: "15px",
    viewBox: "0 0 416.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2000 4989 c-56 -25 -77 -44 -104 -94 l-21 -40 -5 -1684 -5 -1685 -524 478 c-288 262 -541 486 -562 497 -53 26 -125 25 -180 -4 -110 -58 -147 -208 -74 -303 38 -50 1421 -1307 1463 -1329 49 -27 134 -26 184 0 21 11 357 311 747 668 515 468 716 659 732 688 85 168 -91 358 -262 282 -30 -14 -212 -173 -569 -498 l-525 -479 -5 1685 c-3 961 -9 1693 -14 1704 -21 47 -62 89 -110 111 -62 29 -107 30 -166 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148 406 c-85 -31 -135 -90 -145 -173 -10 -90 39 -177 122 -214 38 -18 124 -19 1955 -19 1831 0 1917 1 1955 19 83 37 132 124 122 214 -8 65 -44 119 -104 154 l-48 28 -1910 2 c-1576 2 -1917 0 -1947 -11z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.e59f36132527d9b2303264831441cee0.svg";
export { ForwardRef as ReactComponent };